var utils = {}
utils.extends = function (anyUtils) {
    for (var k in anyUtils)
        utils[k] = anyUtils[k]
}
utils.Group = function (strArr, fn) {
    var groups = {};
    if (fn == undefined)
        fn = function (item) {
            return item;
        }
    strArr.map(function (item) {
        var key = fn(item); // item.substr(1,1);
        var arr = groups[key];
        if (arr === undefined) {
            groups[key] = [];
            arr = groups[key];
        }
        arr.push(item);
    });
    return groups;
}
utils.PropertyToArray = function (obj) {
    var result = [];
    for (var key in obj) {
        var s = {};
        s["key"] = key;
        s["value"] = obj[key];
        result.push(s);
    }
    return result;
}
utils.each = function (arr, fn) {
    for (var i = 0; i < arr.length; i++) {
        fn(arr[i], i);
    }
}
utils.loadScript = function () {
    let cb = {};
    return function (src, callback) {
        let callbacks = cb[src];
        if (callbacks) {
            callbacks.push(callback);
            return;
        }
        callbacks = cb[src] = [callback];

        let ele = document.createElement("script");
        ele.src = src;
        ele.onload = function () {
            while (callbacks.length > 0) {
                let callback = callbacks.pop();
                callback();
            }
        };
        document.body.appendChild(ele);
    }
}();
utils.findCategorysCode = function (datas, value) {
    let reusult = _.find(datas, o => {
        return o.CategoryID == value;
    })
    if (reusult) {
        return reusult.CategoryCode;
    } else {
        return undefined;
    }
}
// 安全转数字：null / undefined / 空字符串 / 非法值 / Infinity 统一返回 0
// isFinite 同时覆盖 NaN 和 ±Infinity，比单独判断 isNaN 更完整
utils.parseNumber = function (value) {
    var n = parseFloat(value);
    return isFinite(n) ? n : 0;
}
export default utils



// WEBPACK FOOTER //
// ./src/utils/objectUtils.js